var HPM  = require('./lib');

module.exports = function(context, opts) {
    return new HPM(context, opts);
};



//////////////////
// WEBPACK FOOTER
// ./~/http-proxy-middleware/index.js
// module id = 3034
// module chunks = 0